var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 11,
    viewBox: "0 0 21 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.58596 8.14001C0.0635414 8.66711 0.0673351 9.51792 0.594439 10.0403C1.12154 10.5628 1.97235 10.559 2.49477 10.0319L5.62536 6.87321C6.8959 5.59128 7.77031 4.71193 8.51121 4.11692C9.23092 3.53893 9.6932 3.34064 10.1072 3.28787C10.3672 3.25474 10.6302 3.25474 10.8902 3.28787C11.3042 3.34064 11.7665 3.53893 12.4862 4.11692C13.2271 4.71193 14.1015 5.59128 15.372 6.87321L18.5026 10.0319C19.025 10.559 19.8759 10.5628 20.403 10.0403C20.9301 9.51792 20.9339 8.66711 20.4114 8.14001L17.2244 4.92445C16.0241 3.71334 15.0431 2.72348 14.169 2.0215C13.26 1.29152 12.3374 0.763099 11.23 0.621941C10.7444 0.560046 10.253 0.560047 9.76741 0.621941C8.65996 0.763099 7.73735 1.29152 6.82839 2.0215C5.95429 2.72348 4.97328 3.71333 3.77296 4.92444L0.58596 8.14001Z",
    fill: "#090A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.e9500bb3e1956ff5affda0714a6ca994.svg";
export { ForwardRef as ReactComponent };